import InnerComponent from '@Components/Sales/EinvoicingEwaybill/EwaybillAuth';
import orgContainer from '@Components/AppContainer';

const EinvoiceEwaybill = () => ((orgContainer(InnerComponent)));
export default EinvoiceEwaybill;
